<template>
  <div style="width: 100%" v-if="!delItem">
    <!--<div style="font-size: 14px;"></div>-->
    <hr class="hr" />
    <div class="notification-block">
      <div class="notification-main-info">
        <h2 class="notification-main-info-title-wrap">
          <span class="notification-main-info-title" v-if="getTitle">
            <!--                    {{ typeof fName.brands != "undefined" ? fName.brands.join(", ") : "" }}-->
            {{ getTitle }}
          </span>
          <span class="notification-main-info-title" v-else>
            Allir framleiðendur
          </span>

          <button @click="showCo" class="notification-main-info-title-remove">
            <span>Eyða</span>
            <trash-icon fill="#a8a8a8" />
          </button>
          <confirm
            :del="del"
            :cancelConfirm="cancelConfirm"
            :showCo="showConfirm"
          ></confirm>
        </h2>
        <template v-if="keyItem != 'brands' && keyItem != 'other'">
          <div class="notification-main-data">
            <span> {{ notifications.description }}</span>
          </div>

          <div
            v-for="(data, key) in notifications.accessories"
            :key="key"
            class="notification-main-data aukahlutir"
          >
            <div
              class="aukahlutir__item" 
              v-for="accesory in data"
              :key="accesory"
            > 
              {{accesory}}
            </div>
          </div>
        </template>
        <div v-if="!!getTransmision" class="notification-main-tags-wrap">
          <span v-for="(transmision, i) in getTransmision" :key="i" class="notification-main-tag">{{
            transmision
          }}</span>
        </div>
      </div>
      <div class="notification-notification-settings-wrap">
        <div class="notification-notification-setting">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 29 29"
            width="29px"
            height="29px"
          >
            <g fill="none" fill-rule="evenodd">
              <circle cx="14.5" cy="14.5" r="14.5" fill="#6F9F13" />
              <path fill="#FFF" d="M5 8h18v13H5z" />
              <path
                fill="#6F9F13"
                d="M5 21.0909091h18V8H5v13.0909091zm.81818182-11.43736365v-.83536363H22.1818182v.83536363L14 15.9257273 5.81818182 9.65354545zM17.078 14.5871818L22.1818182 10.682v9.0122727L17.078 14.5871818zM5.81818182 10.682l5.10545458 3.906-5.10545458 5.1087273V10.682zm10.60445458 4.4067273l5.1807272 5.184H6.39909091l5.18072729-5.1823637L14 16.9419091l2.4226364-1.8531818z"
              />
            </g>
          </svg>
          <div>Fá senda nýja leitarniðurstöður á netfangið</div>
          <label :for="'sc' + d.id" class="switch-checkbox">
            <input
              type="checkbox"
              :id="'sc' + d.id"
              v-model="d.email_notofication"
            />
            <div class="switch-checkbox-mark"></div>
          </label>
        </div>
      </div>
      <div class="notification-notification-info-wrap">
        <div class="notification-notification-info">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 16 16"
            width="16px"
            height="16px"
          >
            <path
              fill="#000"
              fill-rule="nonzero"
              d="M12.8596879 7.9649362c0-.3370213-.2697305-.6100426-.6022127-.6100426H8.57225532V3.6750071c0-.338156-.27438298-.6124255-.61231206-.6124255-.33815603 0-.612539.2742695-.612539.6124255v4.2875461c0 .3382695.27438297.612539.612539.612539h4.29787234c.3321418 0 .6018723-.2731348.6018723-.610156m1.8390922-.0038582c0 3.7217589-3.0166241 6.7388369-6.73758861 6.7388369-3.72119149 0-6.73758865-3.017078-6.73758865-6.7388369 0-3.7217589 3.01639716-6.73883687 6.73758865-6.73883687 3.72096451 0 6.73758861 3.01707797 6.73758861 6.73883687m1.2233759 0C15.922156 3.5642553 12.3579007 0 7.96119149 0 3.56425532 0 0 3.5642553 0 7.961078c0 4.3968227 3.56425532 7.961078 7.96119149 7.961078 4.39670921 0 7.96096451-3.5642553 7.96096451-7.961078"
              opacity=".2"
            />
          </svg>
          <span
            >Leitin virkt í <strong>{{ diffDay }}</strong> daga</span
          >
        </div>
        <div class="notification-notification-info">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 18 16"
            width="18px"
            height="16px"
          >
            <g fill="none" fill-rule="nonzero">
              <path
                stroke="#CCC"
                d="M14.2375 7.57513277c0-3.96376132-2.1875-5.31208997-4.23333333-5.61262105 0-.02030616.00416666-.04061231.00416666-.0649797C10.00833333 1.39800062 9.55416667 1 9 1c-.55416667 0-.99166667.39800062-.99166667.89753202 0 .02436739 0 .04467354.00416667.0649797-2.05.30459231-4.25 1.65698219-4.25 5.62074351C3.7625 12.204936 2.58333333 12.7004061 1 14h16c-1.575-1.3036551-2.7625-1.8031865-2.7625-6.42486723z"
              />
              <path
                fill="#CCC"
                d="M9 16c2.073501 0 3.7756286-.4627907 4-1H5c.21663443.5372093 1.92649903 1 4 1z"
              />
            </g>
          </svg>
          <span
            >Síðast uppfært <strong>{{ create }}</strong></span
          >
        </div>
        <router-link class="notification-notification-btn mt-1" :to="url">
          Skoða leitarniðurstöður
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import f from "../helpers/func";
import TrashIcon from "@/components/svg/trashIcon";
import confirm from "./Confirm.vue";
import routesNames from "@/router/constants";

const moment = require("moment");

export default {
  components: {
    TrashIcon,
    confirm: confirm,
  },

  props: ["d", "keyItem", "lib"],
  
  data: () =>  ({
    delItem: false,
    showConfirm: false
  }),
  
  computed: {
    getTransmision() {
      if (this.fName.other) {
        let res = this.fName.other;
        delete this.fName.other;
        return res;
      }
      if (this.fName.transmision) {
        let res = this.fName.transmision;
        delete this.fName.transmision;
        return res;
      }
    },
    getTitle() {
      const jsD = JSON.parse(this.d.params);
      if(jsD.k7){
        return 'K7 bílasölur';
      }
      this.getTransmision;
      if (typeof this.fName.brands != "undefined") {
        let res = this.fName.brands.join(", ");
        delete this.fName.brands;
        return res;
      }
      return null;
    },

    fName() {
      let ff = f.cleanFilters(JSON.parse(this.d.params));
      let fff = f.addFilersName(ff, this.lib);

      for (let k in fff) {
        if (!fff[k].name) {
          fff[k].name = fff[k].id;
        }
      }
      f.joinFilterName(fff);
      return f.groupFiltersName(fff);
    },

    notifications() {
      const obj = {
        description: '',
        accessories: []
      }

      for (const key in this.fName) {
        if (Object.hasOwnProperty.call(this.fName, key)) {
          if (key === 'aukahlutir') {
            obj.accessories.push(this.fName[key]);
          }
          else if(key === 'other'){

          }
          else {
            obj.description += obj.description.length
              ? ', ' + this.fName[key].join(', ').trim()
              : this.fName[key].join(', ').trim()
          }
        }
      }
      return obj
    },

    create() {
      return moment(this.d.created).format("D.M.YYYY");
    },
    diffDay() {
      let cre = moment(this.d.created);
      return moment().diff(cre, "days");
    },
    url() {
      //let d = window.btoa(this.d.params);

      let d = new URLSearchParams(JSON.parse(this.d.params)).toString();
      let jsonParam = JSON.parse(this.d.params);
      if(jsonParam.k7){
        return '/k7?'+d;
      }


      let _url = routesNames.oldCars;
      switch (this.d.type_id) {
        case 3:
          _url = routesNames.newCars;
          break;
        case 7:
          _url = "/kjarabilar";
          break;
      }
      return _url + "?" + d;
    },
  },
  methods: {
    cancelConfirm() {
      this.showConfirm = false;
    },
    showCo: function () {
      this.showConfirm = true; //new Date().getTime();
    },
    del: function () {
      let api = this.$store.state.api;
      this.$http.post(`${api}/favorites/del`, { id: this.d.id }).then(
        (response) => {
          if (!!response.body) {
            if (response.body.status) {
              this.delItem = true;
            }
          }
        },
        (response) => {
          this.error = response;
        }
      );
    },
  },
  watch: {
    "d.push_notification": {
      handler: function () {
        let api = this.$store.state.api;
        this.$http
          .post(`${api}/notifications/set-push`, { id: this.d.id })
          .then(
            (response) => {
              if (!!response.body) {
              }
            },
            (response) => {
              this.error = response;
            }
          );
      },
    },
    "d.email_notofication": {
      handler: function () {
        let api = this.$store.state.api;
        this.$http
          .post(`${api}/notifications/set-email`, { id: this.d.id })
          .then(
            (response) => {
              if (!!response.body) {
              }
            },
            (response) => {
              this.error = response;
            }
          );
      },
    },
  },
};
</script>
